import { Injectable, TemplateRef } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];

  constructor(private _messageService: MessageService){}

  message(toastMessage: any){
    this._messageService.add(toastMessage);
  }

  succeeded(textOrTpl: string, delay = 2000, key: string = ""){
    //this.show(textOrTpl,{ classname: 'bg-success text-light', delay: 2000 });
    let opt = {severity:'success', detail: textOrTpl, life: delay};
    if (key){
      opt["key"] = key;
    }

    this._messageService.add(opt);
  }

  failed(textOrTpl: string, delay = 60000, key: string = ""){
    //this.show(textOrTpl,{ classname: 'bg-danger text-light', delay: delay });
    let opt = {severity:'error', summary: 'Error', detail: textOrTpl, life: delay};
    if (key){
      opt["key"] = key;
    }

    this._messageService.add(opt);
  }
}
